import React, { useState, useEffect } from 'react';
import { Select, Icon, Button } from 'antd';
import style from '../solo.module.sass';


type Props = {
	lock: any;
	nameCheck: any;
	widgetDrawer: any;
	nodeDetail: any;
	setWidgetDrawer: any;
	onUpdateProperties: any;
    flowDetail: any;
	nodesContext: any;
    flows: any;
	elements: any;
};

type SubflowSchema = {
	flowName?: string;
	startNode?: string;
	nextNode? :string;
};

const { Option } = Select;


export default function Subflow(props: Props) {
	const {
		nodeDetail,
		elements
	} = props;
	const { returningSubflows = []  } = props.nodesContext
	const [subflow, setSubflow] = useState<SubflowSchema>({});
    const [selectedFlow, setSelectedFlow] = useState(null);
    const [selectedStartNode, setSelectedStartNode] = useState(null);
    const [nodes, setNodes] = useState<any[]>([]);
	const [hasReturnNode, setHasReturnNode] = useState(false);

	const nextNodes: any[] = [];
	elements.forEach((e: any) => {
		if (e.data && e.data.type && e.data.type !== 'start' && e.data.type !== 'error' && e.id !== nodeDetail.id) {
			nextNodes.push(e);
		}
	});

	function updateStateByKey(key: keyof SubflowSchema, value: any) {
		setSubflow((prev) => ({
			...prev,
			[key]: value || undefined,
		}));
	}

	function updateProperties() {
		props.onUpdateProperties({
			nodeId: props.nodeDetail.id,
			name: subflow?.flowName || props.nodeDetail.id,
			idChange: true,
			...subflow,
			nextNode: hasReturnNode ? subflow?.nextNode : null,
		});
		props.setWidgetDrawer(false);
		setSubflow({});
		setSelectedFlow(null);
		setSelectedStartNode(null);
		setNodes([]);
	}

    useEffect(() => {
        const flow = props.flows?.find((e: any) => e.name === selectedFlow);
		setNodes(flow?.source?.nodes?.filter((n: any) => { return (n.type !== "subflow" && n.type !== "event" && n.type !== "error") }) ?? []);
		setHasReturnNode(flow && returningSubflows?.some((f: any) => f === flow.name))
		const properties = nodeDetail.data?.propertyDetails
        if (flow && (!properties?.flowName || flow.name !== properties?.flowName)) {
            updateStateByKey('flowName', flow.name);
			updateStateByKey('startNode', null);
            setSelectedStartNode(null);
        }
    }, [selectedFlow])

    useEffect(() => {
        if (selectedStartNode == 'default') {
            updateStateByKey('startNode', null);
            setSelectedStartNode(null);
        } else {
            const node = nodes?.find((n: any) => n.id === selectedStartNode);
            if (node) {
                updateStateByKey('startNode', node.id);
            }
        }
    }, [selectedStartNode])

	useEffect(() => {
		if (props.widgetDrawer) {
			let subflow = {}
			const properties = nodeDetail.data.propertyDetails ?? {};
			if (properties?.flowName && props.flows) {
				subflow = {
					flowName: properties.flowName,
					startNode: properties.startNode
				}
				const flow = props.flows.find((e: any) => e.name === properties.flowName);
				if (flow) {
					setSelectedFlow(flow.name);
					const flowNodes = flow.source?.nodes || [];
					if (properties.startNode) {
						const node = flowNodes.find((n: any) => n.id === properties.startNode);
						if (node) {
							setSelectedStartNode(node.id);
						}
					} else {
						setSelectedStartNode(null);
					}
				}
			} else {
				setSelectedFlow(null);
				setSelectedStartNode(null);
				setNodes([]);
			}
			const nextNode = props.elements.find((el: any) => {
				return el.source === nodeDetail.id;
			});
			setSubflow({ ...subflow, nextNode: nextNode?.target ?? properties.nextNode ?? '' })
		}
	}, [props.widgetDrawer, nodeDetail.data.propertyDetails]);


	// update next node when changes happen in the canvas
	useEffect(() => {
		const findNextNode = elements?.find((el: any) => {
			return el?.source === nodeDetail.id;
		});
		if (findNextNode) {
			updateStateByKey('nextNode', findNextNode.target);
		}
	}, [elements]);

	return (
		<div style={{ height: '100%' }}>
			<div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '0px 15px', margin: '20px 0px' }}>
				<div className={style.label} style={{ color: '#2A2A2A', marginTop: 0, fontSize: 14 }}>
					<label>Flow Name</label>
				</div>
				<Select
					showSearch
					onChange={(e: any) => setSelectedFlow(e)}
					suffixIcon={<Icon style={{ fontSize: '20px', margin: -5 }} type="caret-down" />}
					disabled={props.lock}
					value={selectedFlow || undefined}
					placeholder="Select the journey"
					optionLabelProp="label"
					style={{ width: '100%', borderRadius: 8, color: '#000610', fontSize: 15 }}
					mode="default"
					size="large"
					filterOption={(input, option: any) => {
                        return option && option.props ? option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 : false;
					}}
				>
					{props.flows && props.flows.map((el: any) => {
                        return (
                            <Option key={el.id} value={el.name} label={el.displayName || el.name}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <p style={{ marginLeft: '8px', marginTop: '14px', color: el.id === selectedFlow ? '#0F66C8' : '#000610'}}>
                                            {el.displayName || el.name}
                                        </p>
                                    </div>
                                    {el.name === selectedFlow && (
                                        <Icon type="check" style={{ color: '#0F66C8' }} />
                                    )}
                                </div>
                            </Option>
                        );
					})}
				</Select>
			</div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '0px 15px', margin: '20px 0px' }}>
				<div className={style.label} style={{ color: '#2A2A2A', marginTop: 0, fontSize: 14 }}>
					<label>Start Node</label>
				</div>
				<Select
					showSearch
					onChange={(e: any) => setSelectedStartNode(e)}
					suffixIcon={<Icon style={{ fontSize: '20px', margin: -5 }} type="caret-down" />}
					disabled={props.lock}
					value={selectedStartNode || undefined}
					placeholder="Default Start Node"
					optionLabelProp="label"
					style={{ width: '100%', borderRadius: 8, color: '#000610', fontSize: 15 }}
					mode="default"
					size="large"
					filterOption={(input, option: any) => {
						return option && option.props ? option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 : false;
					}}
				>
                    {nodes.length > 0 && selectedStartNode && <Option key={'default'} value={'default'} label={'Default Start Node'}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <p style={{ marginLeft: '8px', marginTop: '14px', color: selectedStartNode === 'default' ? '#0F66C8' : '#000610'}}>
                                    Default Start Node
                                </p>
                            </div>
                            {selectedStartNode === 'default' && (
                                <Icon type="check" style={{ color: '#0F66C8' }} />
                            )}
                        </div>
                    </Option>}
					{nodes && nodes.map((el: any) => {
                        return (
                            <Option key={el.id} value={el.id} label={el.name}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <p style={{ marginLeft: '8px', marginTop: '14px', color: el.id === selectedStartNode ? '#0F66C8' : '#000610'}}>
                                            {el.name}
                                        </p>
                                    </div>
                                    {el.id === selectedStartNode && (
                                        <Icon type="check" style={{ color: '#0F66C8' }} />
                                    )}
                                </div>
                            </Option>
                        );
					})}
				</Select>
			</div>
			{hasReturnNode && <>
				<div style={{ borderBottom: '1px solid rgb(202, 213, 233)', margin: '20px 18px 20px 18px', }}></div>
				<div style={{ 	display: 'flex', flexDirection: 'column', width: '100%', padding: '0px 15px', }}>
					<div className={style.label} style={{ color: '#2A2A2A', marginTop: 0, fontSize: 14 }}>
						<label>Next Node</label>
					</div>
					<Select
						showSearch
						onChange={(e: any) => updateStateByKey('nextNode', e)}
						suffixIcon={
							<Icon style={{ fontSize: '20px', margin: -5 }} type="caret-down" />
						}
						disabled={props.lock}
						value={subflow.nextNode || undefined}
						placeholder="Select the next node"
						optionLabelProp="label"
						style={{
							width: '100%',
							borderRadius: 8,
							color: '#000610',
							fontSize: 15,
						}}
						mode="default"
						size="large"
						filterOption={(input, option: any) => {
							return option && option.props ? option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 : false;
						}}
					>
						{nextNodes &&
							nextNodes.map((el: any) => {
								return (
									<Option
										key={el.id}
										value={el.id}
										label={
											(el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name) || el.id
										}
									>
										<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
											<div style={{ display: 'flex', flexDirection: 'row' }}>
												<img alt="icons" src={el.data.icon} />
												<p style={{ marginLeft: '8px', marginTop: '14px', color: el.id === subflow.nextNode ? '#0F66C8' : '#000610' }}>
													{(el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name) || el.id}
												</p>
											</div>
											{el.id === subflow.nextNode && (
												<Icon type="check" style={{ color: '#0F66C8' }} />
											)}
										</div>
									</Option>
								);
							})}
					</Select>
				</div>
			</>}
			<div className={style.footer}>
				{!props.lock && (
					<Button style={{ backgroundColor: '#51808C', color: '#FFFFFF', width: '100%', height: 50 }}
						onClick={() => { updateProperties(); }}
					>
						APPLY
					</Button>
				)}
			</div>
		</div>
	);
}

